import { createEventBus } from "../Common/eventBusFactory";

export const OPEN_COPY_TO_CATEGORY_MODAL = "onOpenCopyToCategoryModal";
export const OPEN_DELETE_COMPETITOR_MODAL = "onOpenDeleteCompetitorModal";
export const OPEN_EDIT_REGISTRATION_MODAL = "onEditRegistrationModal";
export const OPEN_PAYMENT_SETTINGS_MODAL = "onOpenPaymentSettingsModal";
export const OPEN_EDIT_PAYMENT_MODAL = "onOpenEditPaymentModal";
export const OPEN_PAYMENT_DOCUMENT = "onOpenPaymentDocument";
export const OPEN_COMPETITOR_STATS = "onOpenCompetitorStats";
export const OPEN_STARTING_LISTS_MODAL = "onOpenStartingListsModal";
export const SEND_NOTIFICATIONS_MODAL = "onSendNotificationsModal";
export const OPEN_ACADEMY_FROM_COMPETITOR_EDIT = "onOpenAcademyFromCompetitorEdit";
export const OPEN_SIDE_EFFECTS_REPORT_MODAL = "onOpenSideEffectsReportModal";
export const OPEN_CATEGORY_SIDEBAR = "onOpenCategorySidebar";

export const eventBus = createEventBus();
